import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ReadMore extends Component {
  constructor(props) {
    super(props);

    this.toggleExpand = this.toggleExpand.bind(this);

    this.state = {
      activated: false,
      expanded: false
    };
  }

  componentDidMount() {
    this.activate();
  }

  componentWillReceiveProps(props) {
    if (props.children !== this.props.children) {
      this.reset();
    }
  }

  componentDidUpdate() {
    this.activate();
  }

  activate() {
    const { maxHeight } = this.props;
    const { activated } = this.state;

    if (!activated && this.element.scrollHeight > maxHeight) {
      this.setState({
        activated: true
      });
    }
  }

  reset() {
    this.setState({
      activated: false,
      expanded: false
    });
  }

  toggleExpand() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    const { maxHeight, children, className, ...otherProps } = this.props;
    const { activated, expanded } = this.state;

    return (
      <div>
        <div {...otherProps} className={expanded ? `${className} expanded` : className} style={{ maxHeight: activated && !expanded ? `${maxHeight}px` : undefined }} ref={elem => (this.element = elem)}>
          {children}
        </div>
        {activated && <a className="read-more-btn" role="button" onClick={this.toggleExpand}>{expanded ? 'Close' : 'Read More'}</a>}
      </div>
    );
  }
}

ReadMore.defaultProps = {
  maxHeight: 250
};

ReadMore.propTypes = {
  maxHeight: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element
  ]).isRequired,
  className: PropTypes.string
};

export default ReadMore;



// WEBPACK FOOTER //
// ./src/components/common/ui/ReadMore.jsx